<template>
  <div>
    <!-- Toolbar amélioré -->
    <v-toolbar
      dense
      color="primary darken-2"
      dark
      class="page-title-animated"
    >
      <v-toolbar-title class="toolbar-title-content">
        <v-layout row align-center>
          <v-flex xs10 sm11>
            <div class="title-wrapper">
              <a href="javascript:history.go(-1)" class="back-button">
                <v-btn icon small class="back-btn-animated">
                  <i class="fas fa-arrow-left"></i>
                </v-btn>
              </a>
              <span class="page-title-text">Advantages</span>
            </div>
          </v-flex>

          <v-flex xs2 sm1 class="text-xs-right">
            <router-link :to="$store.state.close_url2" class="close-button">
              <v-btn icon small class="close-btn-animated">
                <i class="fas fa-close"></i>
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-toolbar-title>
    </v-toolbar>

    <!-- Bandeau WIP amélioré -->
    <div class="wip-banner-animated">
      <div class="wip-content">
        <div class="wip-icon">
          <i class="fas fa-tools"></i>
        </div>
        <div class="wip-text">
          <h3 class="wip-title">Work in Progress</h3>
          <p class="wip-description">This section is being updated with amazing features</p>
        </div>
        <div class="wip-progress">
          <v-progress-linear
            indeterminate
            color="white"
            height="4"
            class="progress-bar"
          ></v-progress-linear>
        </div>
      </div>
    </div>

    <!-- Contenu avec design amélioré -->
    <div class="content-container">
      <v-card class="feature-card" flat>
        <v-card-text class="card-content">
          <!-- Illustration -->
          <div class="illustration-container">
            <div class="main-illustration">
              <i class="fas fa-rocket"></i>
            </div>
            <div class="floating-elements">
              <div class="floating-element element-1">
                <i class="fas fa-star"></i>
              </div>
              <div class="floating-element element-2">
                <i class="fas fa-bolt"></i>
              </div>
              <div class="floating-element element-3">
                <i class="fas fa-gift"></i>
              </div>
            </div>
          </div>

          <!-- Message principal -->
          <div class="main-message">
            <h2 class="message-title">Something Amazing is Coming!</h2>
            <p class="message-description">
              We're working hard to bring you incredible advantages and features
              that will enhance your experience. Stay tuned for updates!
            </p>
          </div>

          <!-- Features à venir -->
          <div class="upcoming-features">
            <v-layout row wrap class="features-grid">
              <v-flex xs12 sm6 md4 v-for="(feature, index) in upcomingFeatures" :key="index">
                <div class="feature-item">
                  <div class="feature-icon" :class="`color-${index + 1}`">
                    <i :class="feature.icon"></i>
                  </div>
                  <div class="feature-text">
                    <h4>{{ feature.title }}</h4>
                    <p>{{ feature.description }}</p>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>

          <!-- Call to Action -->
          <div class="cta-section">
            <v-btn
              color="primary"
              large
              rounded
              class="cta-button"
              @click="notifyMe"
            >
              <i class="fas fa-bell mr-2"></i>
              Notify Me When Ready
            </v-btn>
            <p class="cta-note">We'll let you know as soon as it's live</p>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      upcomingFeatures: [
        {
          icon: 'fas fa-percentage',
          title: 'Exclusive Discounts',
          description: 'Special member-only pricing and seasonal offers'
        },
        {
          icon: 'fas fa-crown',
          title: 'Premium Benefits',
          description: 'Access to exclusive features and early releases'
        },
        {
          icon: 'fas fa-clock',
          title: 'Priority Support',
          description: 'Faster response times and dedicated assistance'
        },
        {
          icon: 'fas fa-gift',
          title: 'Bonus Rewards',
          description: 'Earn points and redeem exciting gifts'
        },
        {
          icon: 'fas fa-shield-alt',
          title: 'Enhanced Security',
          description: 'Advanced protection for your transactions'
        },
        {
          icon: 'fas fa-chart-line',
          title: 'Growth Tools',
          description: 'Analytics and insights to maximize your savings'
        }
      ]
    };
  },
  methods: {
    notifyMe() {
      // Implémentez la logique de notification ici
      this.$store.commit('setSnackBarMessage', "We'll notify you when advantages are available!");
      this.$store.commit('setSnackBarColor', "success");
      this.$store.commit('activateSnackBar', true);
    }
  }
};
</script>

<style scoped>
/* Toolbar amélioré */
.page-title-animated {
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%) !important;
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.3);
}

.toolbar-title-content {
  width: 100%;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
}

.back-button, .close-button {
  text-decoration: none;
}

.back-btn-animated, .close-btn-animated {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 50%;
}

.back-btn-animated:hover {
  transform: translateX(-2px);
  background: rgba(255, 255, 255, 0.1) !important;
}

.close-btn-animated:hover {
  transform: rotate(90deg);
  background: rgba(255, 255, 255, 0.1) !important;
}

.page-title-text {
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Bandeau WIP amélioré */
.wip-banner-animated {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
  margin: 16px;
  border-radius: 16px;
  padding: 20px;
  color: white;
  box-shadow: 0 8px 32px rgba(255, 152, 0, 0.3);
  animation: slideInDown 0.6s ease-out;
  position: relative;
  overflow: hidden;
}

.wip-banner-animated::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transform: rotate(45deg);
  animation: shine 3s infinite;
}

.wip-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 16px;
}

.wip-icon {
  font-size: 2rem;
  animation: bounce 2s infinite;
}

.wip-text {
  flex: 1;
}

.wip-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 4px 0;
}

.wip-description {
  font-size: 0.9rem;
  opacity: 0.9;
  margin: 0;
}

.wip-progress {
  width: 100px;
}

.progress-bar {
  border-radius: 2px;
}

/* Conteneur principal */
.content-container {
  padding: 16px;
}

.feature-card {
  background: transparent !important;
  border-radius: 20px;
}

.card-content {
  padding: 0;
}

/* Illustration */
.illustration-container {
  position: relative;
  text-align: center;
  padding: 40px 20px;
  margin-bottom: 30px;
}

.main-illustration {
  font-size: 4rem;
  color: #1976D2;
  animation: float 3s ease-in-out infinite;
  background: linear-gradient(135deg, #1976D2, #42A5F5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.floating-element {
  position: absolute;
  font-size: 1.5rem;
  animation: float 3s ease-in-out infinite;
}

.floating-element.element-1 {
  top: 20%;
  left: 10%;
  animation-delay: 0s;
  color: #FF9800;
}

.floating-element.element-2 {
  top: 10%;
  right: 15%;
  animation-delay: 1s;
  color: #4CAF50;
}

.floating-element.element-3 {
  bottom: 20%;
  left: 15%;
  animation-delay: 2s;
  color: #E91E63;
}

/* Message principal */
.main-message {
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.message-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1976D2;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #1976D2, #42A5F5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.message-description {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

/* Features à venir */
.upcoming-features {
  margin-bottom: 40px;
}

.features-grid {
  margin: -8px;
}

.feature-item {
  padding: 16px;
  text-align: center;
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
}

.feature-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 2rem;
  transition: all 0.3s ease;
}

.feature-icon.color-1 { background: linear-gradient(135deg, #FF9800, #FF5722); }
.feature-icon.color-2 { background: linear-gradient(135deg, #4CAF50, #388E3C); }
.feature-icon.color-3 { background: linear-gradient(135deg, #2196F3, #1976D2); }
.feature-icon.color-4 { background: linear-gradient(135deg, #9C27B0, #7B1FA2); }
.feature-icon.color-5 { background: linear-gradient(135deg, #607D8B, #455A64); }
.feature-icon.color-6 { background: linear-gradient(135deg, #795548, #5D4037); }

.feature-icon i {
  color: white;
}

.feature-text h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}

.feature-text p {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
}

/* Call to Action */
.cta-section {
  text-align: center;
  padding: 30px 20px;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 20px;
  margin: 20px 0;
}

.cta-button {
  padding: 0 32px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.3);
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4);
}

.cta-note {
  margin-top: 12px;
  color: #666;
  font-size: 0.9rem;
}

/* Animations */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes shine {
  0% {
    transform: rotate(45deg) translateX(-100%);
  }
  100% {
    transform: rotate(45deg) translateX(100%);
  }
}

/* Responsive */
@media (max-width: 959px) {
  .message-title {
    font-size: 1.75rem;
  }

  .main-illustration {
    font-size: 3rem;
  }
}

@media (max-width: 599px) {
  .wip-content {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .wip-progress {
    width: 100%;
  }

  .message-title {
    font-size: 1.5rem;
  }

  .main-illustration {
    font-size: 2.5rem;
  }

  .feature-icon {
    width: 60px;
    height: 60px;
    font-size: 1.5rem;
  }
}
</style>